import { CategoryService } from '@modules/category/category-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';
// import ManageModel from '@shared/manage/manage-model';

export class CategoryField {
 
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/category',
      Permissions.values.categoryRead,
      CategoryService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/category',
      Permissions.values.categoryRead,
      CategoryService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }
}
